import React, { useMemo, useState } from "react";

export default function AdminTable({
    prefix,
    elements = { container: "table", head: "thead", row: "row", loader: "loader", empty: "empty", actions: "actions", subrow: "subrow" },
    columns = [],
    items = [],
    loading = false,
    emptyText = "Нет данных",
    totalText,
    getRowKey = (x, i) => x?._id || i,
    renderActions,
    expandable,
    renderSubrow,
    cols,
    colsMd,
    colsSm
}) {
    const [innerExpandedId, setInnerExpandedId] = useState(null);
    const expandedId = expandable?.expandedId ?? innerExpandedId;
    const onToggle = expandable?.onToggle ?? ((id) => setInnerExpandedId((p) => (p === id ? null : id)));

    const gridVars = useMemo(() => {
        const v = {};
        if (cols) v["--at-cols"] = cols;
        if (colsMd) v["--at-cols-md"] = colsMd;
        if (colsSm) v["--at-cols-sm"] = colsSm;
        return v;
    }, [cols, colsMd, colsSm]);

    const C = `${prefix}__${elements.container}`;
    const H = `${prefix}__${elements.head}`;
    const R = `${prefix}__${elements.row}`;
    const L = `${prefix}__${elements.loader}`;
    const E = `${prefix}__${elements.empty}`;
    const A = `${prefix}__${elements.actions}`;
    const S = `${prefix}__${elements.subrow}`;

    return (
        <div className={`${prefix} admin-table`}>
            <div className={C}>
                <div className={`${H} admin-table__head`} style={gridVars}>
                    {columns.map((c) => (
                        <div key={c.key} className={c.headerClassName || `col col--${c.key}`}>{c.title}</div>
                    ))}
                    {renderActions ? <div className={`${A} admin-table__actions-head`} /> : null}
                </div>

                {loading ? (
                    <div className={`${L} admin-table__loader`}>
                        <div className="spinner" />
                        <span>Загрузка…</span>
                    </div>
                ) : !items?.length ? (
                    <div className={`${E} admin-table__empty`}>{emptyText}</div>
                ) : (
                    items.map((item, index) => {
                        const key = getRowKey(item, index);
                        const isExpanded = expandedId === key;
                        const ctx = { isExpanded, toggle: () => onToggle(key) };
                        return (
                            <React.Fragment key={key}>
                                <div className={`${R} admin-table__row`} style={gridVars}>
                                    {columns.map((c) => (
                                        <div key={`${key}-${c.key}`} className={c.className || `col col--${c.key}`}>
                                            {c.cell ? c.cell(item, index, ctx) : item[c.key]}
                                        </div>
                                    ))}
                                    {renderActions ? <div className={`${A} admin-table__actions`}>{renderActions(item, index, ctx)}</div> : null}
                                </div>
                                {isExpanded && renderSubrow ? <div className={`${S} admin-table__subrow`}>{renderSubrow(item, index, ctx)}</div> : null}
                            </React.Fragment>
                        );
                    })
                )}
            </div>

            {totalText ? <div className={`${prefix}__total admin-table__total`}>{totalText}</div> : null}
        </div>
    );
}
